import type {MergeContext} from '../resolver/types';

export type MergeField = {
	id: string;
	label: string;
	resolve: (ctx: MergeContext) => string;
};

const formatCurrency = (
	amount: number | null | undefined,
	currency: string | null | undefined,
	intl: MergeContext['intl']
): string => {
	if (amount == null) return '';
	try {
		return intl.formatNumber(amount, {style: 'currency', currency: currency || 'USD'});
	} catch {
		return String(amount);
	}
};

// Labels are hardcoded English like the rest of the designer's merge-field surface — a known
// limitation of the stopgap, resolved when the final designer ships.
export const MERGE_FIELDS: MergeField[] = [
	{id: 'project.name', label: 'Project name', resolve: ctx => ctx.data.projectName || ''},
	{id: 'client.name', label: 'Client name', resolve: ctx => ctx.data.clientName || ''},
	{id: 'company.name', label: 'Company name', resolve: ctx => ctx.data.companyName || ''},
	{id: 'salesperson.name', label: 'Salesperson', resolve: ctx => ctx.data.salespersonName || ''},
	{id: 'quote.total', label: 'Quote total', resolve: ctx => formatCurrency(ctx.data.total, ctx.data.currency, ctx.intl)},
];

const BY_ID = new Map(MERGE_FIELDS.map(f => [f.id, f]));
export const getMergeField = (id: string): MergeField | undefined => BY_ID.get(id);
